import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function Flag02FilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 13C4.55228 13 5 13.4477 5 14V21C5 21.5523 4.55229 22 4 22C3.44772 22 3 21.5523 3 21V14C3 13.4477 3.44772 13 4 13Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.38072 3.63451C4.89054 2.44369 8.46671 1.01094 12.2169 2.95008C14.5932 4.17884 17.1632 4.19906 19.586 3.09728C19.8956 2.95652 20.2554 2.98269 20.5413 3.16675C20.8272 3.35081 21 3.66754 21 4.00757V14.0226C21 14.386 20.8029 14.7208 20.4852 14.8971C18.891 15.7817 15.1463 16.8672 11.2983 14.8774C7.89784 13.1192 5.47527 14.6529 4.75434 15.4813C4.48052 15.796 4.04018 15.9076 3.64953 15.7614C3.25889 15.6153 3 15.242 3 14.8249V4.41968C3 4.11347 3.14029 3.82414 3.38072 3.63451Z"
				fill="currentColor"
			/>
		</svg>
	);
}

Flag02FilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Flag02FilledIcon;
